module.exports = __webpack_public_path__ + "img/next.d9b7169d.svg";